import ModalProvider from './ModalProvider'

const Plugin = {
    install(Vue, options) {
        if (this.installed) return

        Vue.component('ModalProvider', ModalProvider)

        Vue.prototype.$modal = new Vue({
            methods: {
                open(options = {}) {
                    this.$emit('modal.open', { modal: null, ...options })
                },
                close() {
                    this.$emit('modal.close')
                }
            }
        })
    }
}

export default Plugin
